module.exports = __webpack_public_path__ + "img/bco-logo-blue.3884980f.png";